var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInclusionvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59998 9.99993C6.59912 8.92081 6.84777 7.85611 7.3265 6.88899C7.80523 5.92187 8.50107 5.07853 9.35967 4.42484C10.2183 3.77116 11.2164 3.32483 12.276 3.12073C13.3357 2.91663 14.4281 2.96028 15.4681 3.24827C16.5081 3.53627 17.4674 4.06081 18.2711 4.78091C19.0748 5.50102 19.7012 6.39719 20.1012 7.39942C20.5013 8.40166 20.6642 9.48281 20.5772 10.5584C20.4903 11.634 20.1558 12.675 19.6 13.5999C19.0314 14.358 18.358 15.0314 17.6 15.5999C16.7137 16.4347 16.0297 17.4608 15.6 18.5999C15.2897 19.1864 14.8535 19.6969 14.3228 20.095C13.792 20.4931 13.1798 20.769 12.53 20.9028C11.8801 21.0365 11.2088 21.025 10.5639 20.8689C9.91906 20.7128 9.31671 20.4161 8.79998 19.9999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 9.99999C10.594 9.4981 10.714 9.00272 10.949 8.55924C11.1841 8.11575 11.5267 7.73832 11.9454 7.46153C12.3641 7.18473 12.8455 7.01741 13.3456 6.97489C13.8458 6.93238 14.3486 7.01602 14.808 7.21817C15.2674 7.42031 15.6688 7.73449 15.9753 8.13194C16.2818 8.52939 16.4838 8.99739 16.5626 9.49309C16.6414 9.98879 16.5945 10.4963 16.4264 10.9693C16.2582 11.4422 15.9741 11.8653 15.6 12.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusionvoice);
export default __webpack_public_path__ + "static/media/inclusion.voice.10fcdc2996eda47f2aacd2237dfd3508.svg";
export { ForwardRef as ReactComponent };